<template>
  <div class="lyf-ui-nav-bar" ref="navBarRef" :class="[
    'color-' + iconColor,
    {
      'fixed': fixed
    }
  ]" :style="{
    zIndex,
    paddingTop: statusBarHeight + 'px'
  }">
    <div class="status-bar" :style="{
      height: statusBarHeight + 'px',
      backgroundColor: bgColor
    }"></div>
    <div class="mask" v-show="toolTipShowFlag" @click="toolTipShowFlag = false" @touchmove="toolTipShowFlag = false">
    </div>
    <div class="lyf-ui-nav-bar-main" :class="{
      'second-head': pageLevel > 1
    }" :style="{
      top: statusBarHeight + 'px',
      backgroundColor: bgColor
    }">
      <slot name="left">
        <div class="lyf-ui-nav-bar-left" v-if="pageLevel > 1">
          <div class="lyf-ui-nav-bar-button" @click="backClick($event)">
            <lyf-icon :size="iconSize" icon="back"></lyf-icon>
          </div>
          <div class="lyf-ui-nav-bar-button" @click="homeClick($event)">
            <lyf-icon :size="iconSize" icon="home"></lyf-icon>
          </div>
        </div>
      </slot>
      <slot>
        <div class="lyf-ui-nav-bar-title" v-if="title">
          <div class="title">{{ title }}</div>
        </div>
      </slot>

      <div class="lyf-ui-nav-bar-right">
        <div class="lyf-ui-nav-bar-capsule" @click="toolTipShowFlag = !toolTipShowFlag">
          <lyf-icon :size="iconSize" icon="more2"></lyf-icon>
        </div>
        <div class="lyf-ui-nav-bar-capsule" @click="exitClick($event)">
          <lyf-icon :size="iconSize" icon="close4"></lyf-icon>
        </div>
      </div>

      <transition name="fade">
        <div class="lyf-ui-nav-bar-tool-tip" v-show="toolTipShowFlag">
          <div class="lyf-ui-nav-bar-tool-tip-item" @click="refreshPage">
            <lyf-icon :size="iconSize" icon="refresh"></lyf-icon>刷新
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LyfNavBar',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
      default: '标题'
    },
    bgColor: {
      type: String,
      default: '#fff',
    },
    // black || white
    iconColor: {
      type: String,
      default: 'black',
    },
    iconSize: {
      type: Number,
      default: 20
    },
    pageLevel: {
      type: Number,
      default: 2,
    },
    // 一级导航时若需要展示头像
    avatar: String,
    fixed: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 100
    },
    statusBarHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      toolTipShowFlag: false,
    }
  },
  mounted() {
    this.$emit('input', this.$refs.navBarRef.clientHeight)
  },
  emits: ['input', 'back-click', 'home-click', 'exit-click'],
  methods: {
    backClick(e) {
      this.$emit('back-click', e)
    },
    homeClick(e) {
      this.$emit('home-click', e)
    },
    exitClick(e) {
      this.$emit('exit-click', e)
    },
    // 刷新页面
    refreshPage() {
      this.toolTipShowFlag = false
      location.reload()
    }
  }
}
</script>

<style scoped>
.lyf-ui-nav-bar {
  position: relative;
  height: 44px;
  box-sizing: content-box;
}

.lyf-ui-nav-bar.fixed .status-bar {
  position: fixed;
}

.lyf-ui-nav-bar.fixed .lyf-ui-nav-bar-main {
  position: fixed;
}

.lyf-ui-nav-bar .status-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 0;
  width: 100%;
  height: 44px;
  background-color: #fff;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-icon {
  color: var(--nav-bar-icon-color);
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-left {
  display: flex;
  align-items: center;
  height: 100%;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-left .lyf-ui-nav-bar-button {
  height: 32px;
  line-height: 32px;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-left .lyf-ui-nav-bar-button:first-child {
  width: 32px;
  margin-left: 16px;
  margin-right: 16px;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-title {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-title .title {
  flex: 1;
  max-width: 160px;
  height: 25px;
  overflow: hidden;
  color: var(--nav-bar-title-color);
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 84px;
  height: 32px;
  margin-right: 12px;
  border: solid 1px var(--N1_6);
  border-radius: 20px;
  background: rgba(#fff, .6);
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-right::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 16px;
  margin: auto;
  background: var(--N1_5);
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-right .lyf-ui-nav-bar-capsule {
  flex: 1;
  height: 30px;
  text-align: center;
  line-height: 30px;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-tool-tip {
  position: absolute;
  top: 100%;
  right: 12px;
  margin-top: 8px;
  padding: 4px 0;
  border: solid 0.5px var(--N1_6);
  border-radius: 8px;
  box-shadow: 0 8px 16px 0 var(--N1_7);
  background-color: rgba(255, 255, 255, .96);
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-tool-tip-item {
  display: flex;
  align-items: center;
  min-width: 120px;
  height: 44px;
  margin-top: 4px;
  padding: 0 16px;
  box-sizing: border-box;
  color: var(--N1_1);
  font-size: 14px;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-tool-tip-item:first-child {
  margin-top: 0;
}

.lyf-ui-nav-bar .lyf-ui-nav-bar-main .lyf-ui-nav-bar-tool-tip-item i {
  margin-right: 8px;
  color: var(--N1_1);
  font-size: 20px;
}

.lyf-ui-nav-bar .second-head .lyf-ui-nav-bar-title {
  position: absolute;
  left: 0;
  right: 0;
  max-width: 160px;
  margin: auto;
}

.lyf-ui-nav-bar .mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

/* 头部icon用白色 */
.color-white .lyf-ui-nav-bar-main {
  background-color: var(--N2_1);
}
.color-white .lyf-ui-nav-bar-main .lyf-ui-nav-bar-title .title,
.color-white .lyf-ui-nav-bar-main .lyf-icon {
  color: var(--N3_1);
}
.color-white .lyf-ui-nav-bar-right {
  border: none;
      background-color: var(--N1_5);
}
.color-white .lyf-ui-nav-bar-right::after {
  background-color: rgba(#fff, .4);
}
</style>